export const getMaxExp = minExp => {
	if (minExp >= 0 && minExp <= 2) return 2;
	else if (minExp > 2 && minExp <= 5) return 5;
	else if (minExp > 5 && minExp <= 8) return 8;
	else if (minExp > 8) return 99;
};
